module.exports = __webpack_public_path__ + "static/media/descuento.8abe00c0.svg";